import { graphql } from '../graphql/generated';

export const PATIENT_SEARCH_QUERY = graphql(`
  query PatientSearch($filter: PatientSearchFilter!) {
    patientSearch(filter: $filter) {
      exact
      entries {
        id
        insuranceShortName
        createdAt
        patientData {
          birthday
          city
          country
          firstName
          lastName
          zip
          svnr
          title
          street
          email
          gender
          phone
          externalId
          insuranceCode
          insuranceCategory
          idCardType
          idCardNumber
          idCardAuthority
          insuredPerson {
            title
            firstName
            lastName
            birthday
            gender
            svnr
            city
            zip
            street
            country
            phone
            email
          }
        }
      }
    }
  }
`);
